import { useScrollFadeIn, staggerStyle } from "@/hooks/useScrollFadeIn";

const plans = [
  {
    icon: "ri-vip-crown-line",
    label: "💗Premium💗",
    emoji: "",
    description: "Full動画が見放題",
    accent: true,
  },
  {
    icon: "ri-shopping-bag-line",
    label: "💙単品販売",
    emoji: "",
    description: "気になる動画を購入",
    accent: false,
  },
  {
    icon: "ri-gift-line",
    label: "無料登録",
    emoji: "🔶",
    description: "100本以上のSample視聴",
    accent: false,
  },
];

export default function VideoSection() {
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>();
  const { ref: descRef, style: descStyle } = useScrollFadeIn<HTMLParagraphElement>({ delay: 0.1 });
  const { ref: cardsRef, style: cardsStyle, visible: cardsVisible } = useScrollFadeIn<HTMLDivElement>({ delay: 0.15 });
  const { ref: ctaRef, style: ctaStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.1 });

  return (
    <section id="video" className="py-20 md:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-10">

        {/* Heading */}
        <div ref={headRef} style={headStyle} className="text-center mb-6 md:mb-10">
          <p className="text-xs tracking-[0.4em] text-amber-700 uppercase mb-2 md:mb-3">Fansite</p>
          <h2
            className="font-en text-2xl md:text-4xl font-light text-stone-800 tracking-widest"
          >
            Video
          </h2>
          <div className="w-8 h-px bg-amber-400 mx-auto mt-3 md:mt-4"></div>
        </div>

        {/* Description */}
        <p ref={descRef} style={descStyle} className="text-center text-stone-500 text-sm md:text-base mb-6 md:mb-8 leading-relaxed tracking-wider">
          限定動画・プレイ記録を公開しています
        </p>

        {/* Plan Cards */}
        <div ref={cardsRef} className="grid grid-cols-3 gap-2 md:gap-4 mb-8">
          {plans.map((plan, i) => (
            <div
              key={plan.label}
              style={staggerStyle(cardsVisible, i, 0.05, 0.12)}
              className={`flex flex-col items-center text-center py-4 md:py-7 px-2 md:px-5 border ${
                plan.accent
                  ? "border-amber-300 bg-amber-50"
                  : "border-stone-200 bg-stone-50"
              }`}
            >
              <div
                className={`w-8 h-8 md:w-12 md:h-12 flex items-center justify-center mb-2 md:mb-3 ${
                  plan.accent ? "text-amber-600" : "text-stone-400"
                }`}
              >
                <i className={`${plan.icon} text-xl md:text-3xl`}></i>
              </div>
              <p
                className={`text-[10px] md:text-sm tracking-wide md:tracking-widest mb-1 md:mb-2 leading-snug ${
                  plan.accent ? "text-amber-700 font-medium" : "text-stone-500"
                }`}
              >
                {plan.emoji}{plan.label}
              </p>
              <p className="text-[10px] md:text-sm text-stone-500 leading-relaxed whitespace-pre-line">{plan.description}</p>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-stone-200 mb-8"></div>

        {/* CTA Buttons */}
        <div ref={ctaRef} style={ctaStyle} className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://candfans.jp/mazo_kawaii"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center gap-2 px-10 py-3 bg-stone-800 text-white text-sm tracking-[0.2em] hover:bg-stone-700 transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-video-line"></i>
            Candfans で見る
          </a>
          <a
            href="https://myfans.jp/muginox"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center gap-2 px-10 py-3 bg-rose-700 text-white text-sm tracking-[0.2em] hover:bg-rose-800 transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line"></i>
            Myfans で見る
          </a>
        </div>

      </div>
    </section>
  );
}
